import { AutomationChannel } from "@redotech/redo-model/advanced-flow/common";
import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import type { AiContextLibrary } from "@redotech/redo-model/ai-context-library";
import {
  AiContextLibrarySchema,
  qualityValues,
} from "@redotech/redo-model/ai-context-library";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const AutomationChannelValues = [
  AutomationChannel.Email,
  AutomationChannel.SMS,
] as const;

const SchemaTypeValues = Object.values(SchemaType) as [
  SchemaType,
  ...SchemaType[],
];

export const updateContextLibraryItem = {
  name: "updateContextLibraryItem" as const,
  input: z.object({
    itemId: zExt.objectId(),
    updates: z
      .object({
        title: z.string().optional(),
        content: z.string().optional(),
        triggerType: createEnum(SchemaTypeValues).optional(),
        strategy: z.string().optional(),
        scenarioType: z.string().optional(),
        channel: createEnum(AutomationChannelValues).optional(),
        quality: createEnum(qualityValues).optional(),
        feedback: z.string().optional(),
      })
      .partial(),
  }),
  output: AiContextLibrarySchema as z.ZodType<AiContextLibrary>,
};
